import { fetchGeneralInfo, getCategoryStats, getChartData } from 'api/api';
import { makeAutoObservable, runInAction } from 'mobx';
import { DictionaryItem } from 'mobx/helpers/dictionary';
import { DtpCategoryStatItemData } from 'mobx/models/dtpCategoryStatItem';

export type GeneralInfoData = {
  categories: DictionaryItem[];
};

export type StatisticData = {
  count: number;
  death_count: number;
  injured_count: number;
  social_risk: number;
  transport_risk: number;
  year: number;
};

export type ChartData = {};

export class DataStore {
  public isGeneralInfoPending = false;
  public isChartPending = false;
  public isStatPending = false;

  private _chartData: DtpCategoryStatItemData[] | null = null;
  public get chartData() {
    return this._chartData;
  }

  private _dictionaries: GeneralInfoData | null = null;
  public get dictionaries() {
    return this._dictionaries;
  }

  private _statistic: StatisticData | null = null;
  public get statistic() {
    return this._statistic;
  }

  constructor() {
    makeAutoObservable(this);
  }

  public async fetchStatistic() {
    this.isStatPending = true;

    try {
      const data = await getCategoryStats();

      runInAction(() => {
        this._statistic = data;
        this.isStatPending = false;
      });
    } catch (e) {
      console.error(e);
    }

    this.isStatPending = false;
  }

  public async fetchChart() {
    this.isChartPending = true;

    try {
      const data = await getChartData();

      runInAction(() => {
        this._chartData = data;
        this.isChartPending = false;
      });
    } catch (e) {
      console.error(e);
    }

    this.isChartPending = false;
  }

  public async fetchGeneralInfo() {
    this.isGeneralInfoPending = true;

    try {
      const data = await fetchGeneralInfo();

      runInAction(() => {
        this._dictionaries = data;
        this.isGeneralInfoPending = false;
      });
    } catch (e) {
      console.error(e);
    }

    this.isGeneralInfoPending = false;
  }
}
